import { FormikErrors, setIn } from 'formik';

import { ValidationResponse } from '../../../types/ValidationResponse';

import { DUPLICATE_PRODUCT_PACK_TYPE_ERROR_CODE } from './validationErrorCodes';

const normalizeValidationPath = (path: string | undefined): string | null => {
    if (!path) {
        return null;
    }

    // Backend paths start with a leading dot (for example ".items[0].productId").
    const normalizedPath = path.trim().replace(/^\./, '');
    return normalizedPath.length ? normalizedPath : null;
};

const isRowLevelFieldPath = (path: string) => {
    return /^(items|samplekits|surcharges)\[\d+\]\./.test(path);
};

const normalizeMoneyFieldPath = (path: string): string => {
    if (/^(items|samplekits|surcharges)\[\d+\]\.(price|value)$/.test(path)) {
        return `${path}.value`;
    }

    return path;
};

const mapValidationCodeToFrontendValue = (path: string, backendMessage: string): string | true => {
    if (isRowLevelFieldPath(path)) {
        return true;
    }

    return backendMessage;
};

export const mapValidationResponseToFormikErrors = <TValues>(response: ValidationResponse): FormikErrors<TValues> => {
    let errors: FormikErrors<TValues> = {};
    let duplicateProductAndPackTypeError: string | null = null;

    response.errors.forEach((validationError) => {
        if (validationError.code === DUPLICATE_PRODUCT_PACK_TYPE_ERROR_CODE) {
            duplicateProductAndPackTypeError = validationError.message;
            return;
        }

        const normalizedPath = normalizeValidationPath(validationError.path);

        if (!normalizedPath) {
            return;
        }

        const formikPath = normalizeMoneyFieldPath(normalizedPath);

        errors = setIn(errors, formikPath, mapValidationCodeToFrontendValue(formikPath, validationError.message));
    });

    if (duplicateProductAndPackTypeError) {
        errors = setIn(errors, 'duplicateItemsError', duplicateProductAndPackTypeError);
    }

    return errors;
};
